import multiguard from 'vue-router-multiguard';
import store from '@/store';
import AuthLayout from '@/layouts/AuthLayout';
import MainLayout from '@/layouts/MainLayout';
import HomeView from '@/views/HomeView';
import LoginView from '@/views/LoginView';
import ClaveUnicaView from '@/views/ClaveUnicaView';
import MedicationRequestView from '@/views/MedicationRequestView';
import MedicationRequestViewForeigs from '@/views/MedicationRequestViewForeigs.vue';
import MedicationRequestListView from '@/views/MedicationRequestListView';
import MedicationRequestPreview from '@/views/MedicationRequestPreview';
import PrintedFolioRequestListView from '@/views/PrintedFolioRequestListView';

import auth from '@/router/middlewares/auth';
import token from '@/router/middlewares/token';
import guest from '@/router/middlewares/guest';
import role from '@/router/middlewares/role';

export default {
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: MainLayout,
      beforeEnter: multiguard([auth]),
      children: [
        {
          path: '/',
          name: 'home',
          component: HomeView
        },
        {
          path: 'medication-requests',
          name: 'medication-requests-list',
          beforeEnter: multiguard([role('medic')]),
          component: MedicationRequestListView
        },
        {
          path: 'medication-requests/create',
          name: 'medication-requests-form',
          beforeEnter: multiguard([role('medic')]),
          component: MedicationRequestView
        },
        {
          path: 'medication-requests/:prescriptionId',
          name: 'medication-requests-preview',
          beforeEnter: multiguard([role('medic')]),
          component: MedicationRequestPreview
        },
        {
          path: 'medication-requests-foreign/create',
          name: 'medication-requests-foreign',
          beforeEnter: multiguard([role('medic')]),
          component: MedicationRequestViewForeigs
        },
        {
          path: 'printed-folio-requests',
          name: 'printed-folio-requests',
          component: PrintedFolioRequestListView
        }
      ]
    },
    {
      path: '/auth',
      component: AuthLayout,
      children: [
        {
          path: 'login',
          name: 'login',
          component: LoginView,
          beforeEnter: multiguard([guest])
        },
        {
          path: 'claveunica',
          name: 'claveunica',
          props: { action: 'login' },
          beforeEnter: multiguard([guest]),
          component: ClaveUnicaView
        },
        {
          path: 'logout',
          name: 'logout',
          props: { action: 'logout' },
          beforeEnter: multiguard([auth]),
          component: ClaveUnicaView
        }
      ]
    }
  ]
};
